import Vue from "vue";
import store from "@/store";

/**
 * Productos agotados: el local los marca en pleno servicio y no se pueden pedir en meseros ni en caja. La lista es
 * corta y viene del servidor; se renueva cada minuto y se guarda en el equipo para seguir funcionando sin conexión
 * (el servidor también rechaza la línea al guardar el pedido, la última defensa). Los agotados son de la sucursal de
 * esta caja (otra sede puede tener existencia) y vencen al terminar el día.
 */
const CLAVE = "productos_agotados";
const estado = Vue.observable({ ids: {}, puede: false });
let temporizador = null;

try {
  const guardado = JSON.parse(localStorage.getItem(CLAVE) || "{}");
  if (guardado && typeof guardado === "object") estado.ids = guardado;
} catch (e) {
  // sin almacenamiento arranca vacía
}

function aplicar(items) {
  const ids = {};
  (items || []).forEach((p) => {
    ids[p.id] = p.name;
  });
  estado.ids = ids;
  try {
    localStorage.setItem(CLAVE, JSON.stringify(ids));
  } catch (e) {
    // no es grave
  }
}

// La sucursal de esta caja, de los meseros o de la pantalla de pedidos.
function sucursal() {
  const instalacion = store.getters.installation;
  if (instalacion && instalacion.subsidiary_id) return instalacion.subsidiary_id;
  const tienda = store.getters.store;
  return (tienda && tienda.bus_subsidiary_id && tienda.bus_subsidiary_id.id) || null;
}

export function esAgotado(idProducto) {
  return !!idProducto && Object.prototype.hasOwnProperty.call(estado.ids, idProducto);
}

// Solo administración y caja marcan o devuelven a la venta; el mesero ve la lista.
export function puedeMarcarAgotados() {
  return estado.puede;
}

export function listaAgotados() {
  return Object.keys(estado.ids).map((id) => ({ id, name: estado.ids[id] }));
}

export async function cargarAgotados(http) {
  const id = sucursal();
  if (!id) return;
  try {
    const r = await http.get("api/v1/pos/agotados", { sucursal: id }, false, false, false);
    if (r && r.items) {
      aplicar(r.items);
      estado.puede = (r.module_actions || []).includes("marcar");
    }
  } catch (e) {
    // sin conexión se queda con la última lista
  }
}

// Una sola vez por pantalla abierta: baja la lista ya y cada minuto.
export function vigilarAgotados(http) {
  cargarAgotados(http);
  if (!temporizador) temporizador = setInterval(() => cargarAgotados(http), 60000);
}

export async function marcarAgotado(http, producto, agotado) {
  const r = await http.post("api/v1/pos/agotados/" + producto.id, { agotado, sucursal: sucursal() });
  if (r && r.success) {
    const ids = { ...estado.ids };
    if (agotado) ids[producto.id] = producto.name;
    else delete ids[producto.id];
    estado.ids = ids;
    try {
      localStorage.setItem(CLAVE, JSON.stringify(ids));
    } catch (e) {
      // no es grave
    }
  }
  return r;
}
